export default __webpack_public_path__ + "static/media/Punto_08_Piazza_della_Repubblica_FRA_Def.c3d31ad2.aac";